/**
 * Top-of-page environment indicator. Yellow for dev, red for prod.
 * Reads `VITE_ENV_NAME` at runtime; unknown values render the dev style
 * so unconfigured local dev still gets a visible banner.
 */
export function EnvBanner(): JSX.Element {
  const env = import.meta.env.VITE_ENV_NAME ?? 'dev';
  const isProd = env === 'prod';
  const bg = isProd ? 'bg-red-600' : 'bg-yellow-400';
  const fg = isProd ? 'text-white' : 'text-yellow-950';
  const label = isProd ? 'PROD' : 'DEV';
  return (
    <div
      role="status"
      aria-live="polite"
      className={`${bg} ${fg} px-4 py-1 text-center text-sm font-semibold`}
    >
      {label} environment
    </div>
  );
}
